import { shipmentLegIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

const OverboxServiceSchema = z.enum(["apc", "epg"]);
const OverboxCarrierSchema = z.enum(["fedex", "ups", "dhl"]);

export const purchaseOverboxLabel = {
  name: "purchaseOverboxLabel" as const,
  input: z.object({
    service: OverboxServiceSchema,
    carrier: OverboxCarrierSchema,
    parcel: z.object({
      lengthInches: z.number().positive(),
      widthInches: z.number().positive(),
      heightInches: z.number().positive(),
      weightOunces: z.number().positive(),
    }),
    // Ship-from location external id: sets the outer from-address and scopes
    // binding. Omitted falls back to the team address + service-only scope.
    locationId: z.string().nullish(),
  }),
  output: z.object({
    labelUrl: z.string(),
    trackingNumber: z.string(),
    shipmentLegId: shipmentLegIdFormat.schema,
  }),
};
